<!-- Pagination component -->
<template>
  <div class="pagination-box" v-show="total>12">
    <!-- <div class="pagination-box"> -->
    <span class="prev-title">上一頁</span>
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="num"
      :page-size="12"
      :total="total"
      class="pagination-page"
      @prev-click="prevClick"
      @next-click="nextClick"
      @current-change="currentChange"
    ></el-pagination>
    <span class="next-title">下一頁</span>
  </div>
</template>

<script>
export default {
  name: "twPagination",
  props: {
    type: {
      type: String,
      default: "master" // master---main warehouse pagination slave---sub warehouse pagination sign---signing pagination listing---inspection list pagination callRepair---repair request pagination taskting---dispatch pagination
    }
  },
  data() {
    return {
      num: 1
    };
  },

  components: {},

  created() {
    this.$store.state.nowPageIndex = 1;
  },

  methods: {
    prevClick(_index) {},
    nextClick(_index) {},
    currentChange(_index) {
      this.num = _index;
      this.$store.state.nowPageIndex = _index;
      this.$store.commit("addData", { key: "storageSelectData", value: [] });
      let startNum = (_index - 1) * 12;
      let endNum = startNum + 12;
      endNum > this.total && (endNum = this.total);
      // this[this.type + "Paging"](startNum, endNum);
      this.$emit("upDatePageIndex", _index);

      let findData = this.$store.state[this.type + "FilterData"].slice(
        startNum,
        endNum
      );
      this.$store.commit("addData", {
        key: this.type + "FindData",
        value: findData
      });
    }
  },
  computed: {
    total() {
      // master---main warehouse pagination slave---sub warehouse pagination sign---signing pagination listing---inspection list pagination callRepair---repair request pagination taskting---dispatch pagination
      return this.$store.state[this.type + "FilterData"].length;
    },
    // Whether to update pagination parameters
    isUpdateSortNum() {
      return this.$store.state.isUpdateSortNum;
    }
  },
  watch: {
    // Pagination initialization
    isUpdateSortNum(val) {
      if (val) {
        this.num = 1;
        this.$store.commit("addData", { key: "isUpdateSortNum", value: false });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.pagination-page {
  display: inline-block;
  padding: 2px 38px;
}
.pagination-box {
  height: 34px;
  display: inline-block;
  line-height: 34px;
  position: relative;
  z-index: 10;
  left: 20px;
}
.prev-title {
  display: inline-block;
  height: 34px;
  position: absolute;
  z-index: -1;
}
.next-title {
  display: inline-block;
  height: 34px;
  position: absolute;
  z-index: -1;
  right: 45px;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/tw-pagination.vue